/**
 * Код модуля скопирован из библиотеки https://github.com/TheJLifeX/ngx-scroll-position-restoration
 * т.к. сама библиотека не работает с Angular выше 14 версии
 */
export * from './scroll-position-restoration.module';
export * from './scroll-position-restoration-config';
export * from './custom-router-outlet.directive';
